import { faFaceGrimace, faFaceGrin, faFaceGrinHearts, faFaceMeh, faFaceSmile } from "@fortawesome/free-regular-svg-icons";

export const PAGES = {
  HOME: "Home",
  SEARCH: "Search",
  SCORETYPE: "Score Type",
  SORT: "Sort",
  FAVORITE: "Favorites",
  FINALSCORE: "Score",
};

export const ratingButtonsInfo = [
  {
    score: 1,
    color: "darkGrayPrimary.main",
    icon: faFaceGrimace,
    value: "Skip it",
  },
  {
    score: 2,
    color: "darkPinkPrimary.main",
    icon: faFaceMeh,
    value: "Okay with it",
  },
  {
    score: 3,
    color: "greenPrimary.main",
    icon: faFaceSmile,
    value: "Like it",
  },
  {
    score: 4,
    color: "darkBluePrimary.main",
    icon: faFaceGrin,
    value: "Really like it",
  },
  {
    score: 5,
    color: "darkPurplePrimary.main",
    icon: faFaceGrinHearts,
    value: "Love it",
  },
];

export const scoreTypeBtns = [
  {
    id: 1,
    title: "Nostalgia",
    summary: "as your past self",
  },
  {
    id: 2,
    title: "React",
    summary: "your first listen",
  },
  {
    id: 3,
    title: "Replay",
    summary: "your recent relisten",
  },
];